import { render, staticRenderFns } from "./_follow_recomend.vue?vue&type=template&id=6552753d&"
import script from "./_follow_recomend.vue?vue&type=script&lang=js&"
export * from "./_follow_recomend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports